var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-block',{staticClass:"multiline-text-view"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.multilineText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }